module.exports = __webpack_public_path__ + "static/media/boheme.006872c4.jpg";